import axios from 'axios';

const settings = window.APP_SETTINGS;


export const getSmartChronologyFileUrl = (orderId) => {
	return axios.get(`${settings.EXPERT_API_BASE_URL}/orders/${orderId}/chronology/url`);
};